var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wordPress",staticClass:"custom-iframe",on:{"scroll":_vm.handlerScroll}},[_c('iframe',{staticStyle:{"border":"none","display":"flex","width":"100%"},attrs:{"id":'iframe-wordpress-id-' + _vm.postId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }